import getInvestmentSummary from "./getInvestmentSummary.ts";
import getSoldVBCUnits from "./getSoldVBCUnits.ts";
import getSolutions from "./getSolutions.ts";

const api = {
  get: {
    investmentSummary: getInvestmentSummary,
    soldVBCUnits: getSoldVBCUnits,
    solutions: getSolutions,
  },
};

export default api;
